import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="w-full border-t border-background-200 bg-secondary-100">
      <div className="w-full px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-4">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-movie-2-fill text-lg" />
              </span>
              <span className="font-heading text-lg font-bold text-foreground-950">
                西瓜视频<span className="text-primary-500">免费</span>
              </span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-foreground-600">
              一站式免费高清影视视频平台，汇集电影、电视剧与综艺节目，
              分类清晰、搜索快捷，让每一次打开都能轻松找到想看的内容。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-950">
              <a href="#footer-nav" className="hover:text-primary-600">内容导航</a>
            </h4>
            <ul id="footer-nav" className="mt-4 space-y-2.5 text-sm text-foreground-600">
              <li><Link to="/" className="hover:text-primary-600">首页</Link></li>
              <li><Link to="/category/movie" className="hover:text-primary-600">电影频道</Link></li>
              <li><Link to="/category/tv" className="hover:text-primary-600">电视剧频道</Link></li>
              <li><Link to="/category/variety" className="hover:text-primary-600">综艺频道</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-950">
              <a href="#footer-contact" className="hover:text-primary-600">联系我们</a>
            </h4>
            <ul id="footer-contact" className="mt-4 space-y-2.5 text-sm text-foreground-600">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-foreground-400" />
                support@xigua-video.example
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-customer-service-2-line text-foreground-400" />
                周一至周日 09:00 - 21:00
              </li>
              <li><Link to="/about" className="hover:text-primary-600">关于我们</Link></li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-secondary-200 pt-6 text-xs text-foreground-500 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2025 西瓜视频免费 · 本网站为演示站点，所有影片信息与播放功能均为前端展示，不提供真实视频资源。</p>
          <p className="whitespace-nowrap">仅供学习交流使用</p>
        </div>
      </div>
    </footer>
  );
}